import {FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl} from '@angular/forms';
import {Component, Input, OnInit} from '@angular/core';
import {SitePagesService} from '../../../services/site-pages.service';
import {GetSiteResponseDto} from '../../../models/GetSiteResponseDto';
import {PostSitePageRequestDto} from '../../../models/post/PostSitePageRequestDto';
import {ToastsManager} from 'ng2-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-add-page',
    templateUrl: './add-page.component.html',
    styleUrls: ['./add-page.component.css']
})
export class AddPageComponent implements OnInit {

    form: FormGroup;
    isLoading = false;
    @Input()
    site: GetSiteResponseDto;

    constructor(private fb: FormBuilder,
                private sitePageService: SitePagesService,
                private translateService: TranslateService,
                private toastr: ToastsManager) {}

    ngOnInit() {
        this.form = this.fb.group({
            'pagePath': ['', [Validators.required, this.validatePagePath()]]
        });
    }

    onSubmit($event): void {
        // Set all the fields dirty
        for (const control in this.form.controls) {
            const field = this.form.controls[control];
            (field as FormControl).markAsDirty();
            field.updateValueAndValidity();
        }

        if (!this.form.valid) {
            return;
        }

        const newSitePage = new PostSitePageRequestDto();
        newSitePage.siteId = this.site.id;
        newSitePage.path = this.form.value['pagePath'];

        this.sitePageService.addSitePage(newSitePage).subscribe(
            response => {
                this.translateService.get('pageCreated').subscribe(result => {
                    this.toastr.success(result);
                });
                this.sitePageService.addSitePageSuccess(response.body);
            },
            error => {
                if (error.status === 302) {
                    this.translateService.get('sitePageExists').subscribe(result => {
                        this.toastr.error(result);
                    });
                } else {
                    this.translateService.get('genericErrorMessage').subscribe(result => {
                        this.toastr.error(result);
                    });
                }
                console.log(error);
            }
        );

    }

    private validatePagePath(): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
            const isValid = /^(\/?[a-zA-Z0-9]+((-|_)?[a-zA-Z0-9]+)?)+$/.test(control.value);
            return !isValid ? {'validatePagePath': {valid: false}} : null;
        };
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/site/add-page/add-page.component.ts